module.exports = __webpack_public_path__ + "img/11.78346ce5.png";